module.exports = __webpack_public_path__ + "img/drag-list2.3671e6d5.svg";